import React from "react";

import VisionProposalTeamDisplay from "./VisionProposalTeamDisplay";

const VisionAuroraDisplay = () => (
  <VisionProposalTeamDisplay
    inProgressHeader="Your Vision proposal and Aurora design are in progress"
    nextStepsTitle="Next: Add finance & equipment details"
    nextStepsText="Your design team is building the Aurora design and the Vision proposal together. Add your financing preferences and equipment selections in Vision so both match what you need."
    designLabel="Powur Design Team — Vision proposal + Aurora design"
  />
);

export default VisionAuroraDisplay;
